(() => {
  const initOne = (root) => {
    if (!root || root.dataset.hdInited === "1") return;
    root.dataset.hdInited = "1";

    const btn = root.querySelector("[data-hd-sidebar-toggle]");
    const mobile = root.querySelector("[data-hd-sidebar-mobile]");
    const overlay = root.querySelector("[data-hd-sidebar-overlay]");
    const closeBtn = root.querySelector("[data-hd-sidebar-close]");

    if (!btn || !mobile || !overlay) return;

    // Move to <body> to avoid "fixed inside transformed parent"
    // Only move once
    if (btn.dataset.hdMoved !== "1") {
      btn.dataset.hdMoved = "1";
      overlay.dataset.hdMoved = "1";
      mobile.dataset.hdMoved = "1";

      // Optional: keep a reference id for debugging
      btn.setAttribute("data-hd-floating", "1");
      overlay.setAttribute("data-hd-floating", "1");
      mobile.setAttribute("data-hd-floating", "1");

      document.body.appendChild(btn);
      document.body.appendChild(overlay);
      document.body.appendChild(mobile);
    }

    const escClose = (e) => {
      if (e.key === "Escape") close();
    };

    const open = () => {
      mobile.classList.add("is-open");
      overlay.classList.add("show");
      btn.classList.add("btn-zindex");

      btn.setAttribute("aria-expanded", "true");
      mobile.setAttribute("aria-hidden", "false");

      document.addEventListener("keydown", escClose);
    };

    const close = () => {
      mobile.classList.remove("is-open");
      overlay.classList.remove("show");
      btn.classList.remove("btn-zindex");

      btn.setAttribute("aria-expanded", "false");
      mobile.setAttribute("aria-hidden", "true");

      document.removeEventListener("keydown", escClose);
    };

    btn.addEventListener("click", () => {
      const isOpen = mobile.classList.contains("is-open");
      if (isOpen) close();
      else open();
    });

    overlay.addEventListener("click", close);
    if (closeBtn) closeBtn.addEventListener("click", close);
  };

  const init = () => {
    document
      .querySelectorAll("[data-hd-blog-sidebar]")
      .forEach((root) => initOne(root));
  };

  // Shopify theme editor sometimes re-renders sections
  // Re-run init on these events to re-bind safely
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
